webpackJsonp([19],{

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.share = undefined;

var _axios = __webpack_require__(62);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var share = function share(url) {
  return _axios2.default.get('http://212.64.24.247:3003/jssdk/wxconfig?url=' + url);
};

exports.share = share;

/***/ }),

/***/ 133:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 134:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 135:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(145),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(148),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(134)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(147),
  /* scopeId */
  "data-v-69074416",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(133)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(146),
  /* scopeId */
  "data-v-242453f1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 145:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 146:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "my_scroller",
    staticClass: "scrolls",
    on: {
      "scroll": function($event) {
        return _vm.scroll($event.target)
      }
    }
  }, [_c('div', {
    ref: "my_scroller_box",
    staticClass: "scroll-box",
    style: (_vm.diff ? {
      transform: ("translate3d(0, " + _vm.diff + "px, 0)")
    } : '')
  }, [(_vm.topLoadMethod) ? _c('div', {
    staticClass: "action-block",
    class: {
      'c-black': _vm.colorBlack
    },
    style: ({
      height: (_vm.topBlockHeight + "px"),
      top: ("-" + _vm.topBlockHeight + "px")
    })
  }, [_c('svg', {
    staticClass: "icon",
    class: {
      'icon-arrow': _vm.state === 'trigger',
        'icon-loading': _vm.state === 'loading',
        'c-black': _vm.colorBlack
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.iconLink
    }
  })]), _vm._v("\n      " + _vm._s(_vm.refreshText) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "scroll-container"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.onInfinite) ? _c('div', {
    ref: "load",
    staticClass: "load"
  }, [(_vm.loadingState == 0) ? _c('p', {
    class: {
      'c-black': _vm.colorBlack
    }
  }, [_vm._v(_vm._s(_vm.isData === 3 ? '' : '已经到底啦~'))]) : (_vm.loadingState == 3) ? _c('p', {
    class: {
      'c-black': _vm.colorBlack
    },
    on: {
      "click": function($event) {
        _vm.loadingState = 1;
        _vm.deInit()
      }
    }
  }, [_vm._v("加载失败，点击重试")]) : _c('p', [_c('svg', {
    staticClass: "load-icon",
    class: {
      'c-black': _vm.colorBlack
    },
    attrs: {
      "viewBox": "0 0 64 64"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-loading"
    }
  })]), _vm._v(" "), _c('span', {
    class: {
      'c-black': _vm.colorBlack
    }
  }, [_vm._v("加载中...")])])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 147:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading_container"
  }, [_vm._v("\n\t磊\n")])
},staticRenderFns: []}

/***/ }),

/***/ 148:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 149:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.transitionName
    }
  }, [_c('router-view', {
    staticClass: "Router"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(20);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(55);

var _vuex2 = _interopRequireDefault(_vuex);

var _mutations = __webpack_require__(87);

var _mutations2 = _interopRequireDefault(_mutations);

var _action = __webpack_require__(85);

var _action2 = _interopRequireDefault(_action);

var _getters = __webpack_require__(86);

var _getters2 = _interopRequireDefault(_getters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var state = {
  userInfo: null,
  searchKey: '',
  cartList: 0,
  categoryType: -1,
  activeCity: '杭州',
  activeCityOnce: true,
  showLoading: true,
  loginState: '',
  wxLoginUrl: '',
  activeAddress: null,
  showAlert: false,
  alertMessage: '提示',
  orderList: [],

  position: {},
  arrPageName: 'index',

  platform: 'h5',
  appVersion: 1,

  acitiveLocalNo: '',
  acitiveLocal: '',
  isBack: false

};

exports.default = new _vuex2.default.Store({
  state: state,
  getters: _getters2.default,
  actions: _action2.default,
  mutations: _mutations2.default
});

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SAVE_ADDRESS = exports.SAVE_ADDRESS = 'SAVE_ADDRESS';
var SAVE_SEARCHKEY = exports.SAVE_SEARCHKEY = 'SAVE_SEARCHKEY';
var SAVE_CARTLIST = exports.SAVE_CARTLIST = 'SAVE_CARTLIST';
var SAVE_CATEGORYTYPE = exports.SAVE_CATEGORYTYPE = 'SAVE_CATEGORYTYPE';
var SAVE_ACTIVECITY = exports.SAVE_ACTIVECITY = 'SAVE_ACTIVECITY';
var SAVE_ORDERLIST = exports.SAVE_ORDERLIST = 'SAVE_ORDERLIST';
var SET_POSITION = exports.SET_POSITION = 'SET_POSITION';
var SAVE_PAGE = exports.SAVE_PAGE = 'SAVE_PAGE';

var SET_ACTIVELOCAL = exports.SET_ACTIVELOCAL = 'SET_ACTIVELOCAL';

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loading = __webpack_require__(143);

var _loading2 = _interopRequireDefault(_loading);

var _scroll = __webpack_require__(144);

var _scroll2 = _interopRequireDefault(_scroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { loading: _loading2.default, scroll: _scroll2.default };

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


!function (window) {
  var docWidth = 750;

  var doc = window.document,
      docEl = doc.documentElement,
      resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';

  var recalc = function refreshRem() {
    var clientWidth = docEl.getBoundingClientRect().width;

    docEl.style.fontSize = 20 * (clientWidth / docWidth) * 5 + 'px';

    return refreshRem;
  }();

  docEl.setAttribute('data-dpr', window.navigator.appVersion.match(/iphone/gi) ? window.devicePixelRatio : 1);

  if (/iP(hone|od|ad)/.test(window.navigator.userAgent)) {
    doc.documentElement.classList.add('ios');

    if (parseInt(window.navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/)[1], 10) >= 8) {
      doc.documentElement.classList.add('hairline');
    }
  }

  if (!doc.addEventListener) return;
  window.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);
}(window);

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(20);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(150);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var index = function index(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__(174));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var companyPage = function companyPage(r) {
  return __webpack_require__.e/* require.ensure */(5).then((function () {
    return r(__webpack_require__(160));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var companyActor = function companyActor(r) {
  return __webpack_require__.e/* require.ensure */(6).then((function () {
    return r(__webpack_require__(159));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var companyBusiness = function companyBusiness(r) {
  return __webpack_require__.e/* require.ensure */(8).then((function () {
    return r(__webpack_require__(157));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var broker = function broker(r) {
  return __webpack_require__.e/* require.ensure */(17).then((function () {
    return r(__webpack_require__(161));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var project = function project(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__(173));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var companyActorOption = function companyActorOption(r) {
  return __webpack_require__.e/* require.ensure */(7).then((function () {
    return r(__webpack_require__(158));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var actorDetail = function actorDetail(r) {
  return __webpack_require__.e/* require.ensure */(10).then((function () {
    return r(__webpack_require__(169));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var actorExperience = function actorExperience(r) {
  return __webpack_require__.e/* require.ensure */(11).then((function () {
    return r(__webpack_require__(168));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var programList = function programList(r) {
  return __webpack_require__.e/* require.ensure */(12).then((function () {
    return r(__webpack_require__(167));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var showPics = function showPics(r) {
  return __webpack_require__.e/* require.ensure */(15).then((function () {
    return r(__webpack_require__(164));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var showText = function showText(r) {
  return __webpack_require__.e/* require.ensure */(13).then((function () {
    return r(__webpack_require__(166));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var brand = function brand(r) {
  return __webpack_require__.e/* require.ensure */(16).then((function () {
    return r(__webpack_require__(163));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var activity = function activity(r) {
  return __webpack_require__.e/* require.ensure */(4).then((function () {
    return r(__webpack_require__(162));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var winningr = function winningr(r) {
  return __webpack_require__.e/* require.ensure */(2).then((function () {
    return r(__webpack_require__(171));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var album = function album(r) {
  return __webpack_require__.e/* require.ensure */(14).then((function () {
    return r(__webpack_require__(165));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var music = function music(r) {
  return __webpack_require__.e/* require.ensure */(9).then((function () {
    return r(__webpack_require__(172));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var winningrLink = function winningrLink(r) {
  return __webpack_require__.e/* require.ensure */(3).then((function () {
    return r(__webpack_require__(170));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  routes: [{
    path: '',
    redirect: '/index'
  }, {
    path: '/index',
    name: 'index',
    component: index
  }, {
    path: '/companyPage',
    name: 'companyPage',
    component: companyPage
  }, {
    path: '/companyActor',
    name: 'companyActor',
    component: companyActor
  }, {
    path: '/companyBusiness',
    name: 'companyBusiness',
    component: companyBusiness
  }, {
    path: '/broker',
    name: 'broker',
    component: broker
  }, {
    path: '/project',
    name: 'project',
    component: project
  }, {
    path: '/companyActorOption',
    name: 'companyActorOption',
    component: companyActorOption
  }, {
    path: '/actorDetail',
    name: 'actorDetail',
    component: actorDetail
  }, {
    path: '/actorExperience',
    name: 'actorExperience',
    component: actorExperience
  }, {
    path: '/programList',
    name: 'programList',
    component: programList
  }, {
    path: '/showPics',
    name: 'showPics',
    component: showPics
  }, {
    path: '/showText',
    name: 'showText',
    component: showText
  }, {
    path: '/brand',
    name: 'brand',
    component: brand
  }, {
    path: '/activity',
    name: 'activity',
    component: activity
  }, {
    path: '/winningr',
    name: 'winningr',
    component: winningr
  }, {
    path: '/album',
    name: 'album',
    component: album
  }, {
    path: '/music',
    name: 'music',
    component: music
  }, {
    path: '/winningrLink',
    name: 'winningrLink',
    component: winningrLink
  }]
});

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(135)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(149),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
};

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__(54);
exports.default = {
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
};

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mUtils = __webpack_require__(9);

var mobile = _interopRequireWildcard(_mUtils);

var _getData = __webpack_require__(13);

var getData = _interopRequireWildcard(_getData);

var _vuex = __webpack_require__(55);

var _weixinJsSdk = __webpack_require__(153);

var _weixinJsSdk2 = _interopRequireDefault(_weixinJsSdk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  name: "app",
  data: function data() {
    return {
      transitionName: ""
    };
  },

  computed: {},
  mounted: function mounted() {
    var _this = this;

    window.addEventListener("popstate", function () {
      _this.$store.state.isBack = true;
    });
    var url = window.location.href.split('#')[0];
    getData.share(encodeURIComponent(url)).then(function (res) {
      _weixinJsSdk2.default.config({
        debug: false,
        appId: res.data.appid,
        timestamp: res.data.timestamp,
        nonceStr: res.data.noncestr,
        signature: res.data.signature,
        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone']
      });
      var shareCont = {
        title: '凯艺娱乐',
        shareContent: '香港凯艺娱乐发展有限公司（SUPREME ART ENTERTAINMENT  LTD.），现主要业务包括明星经纪代理、艺人推广等。',
        url: url,
        imgUrl: 'http://static1.joubn.com/static/logo.png'
      };
      mobile.wxshare(_weixinJsSdk2.default, shareCont);
    });
  },

  methods: {},
  watch: {
    $route: function $route() {
      if (this.$store.state.isBack) {
        this.transitionName = "slide-right";
      } else {
        this.transitionName = "slide-left";
      }
      this.$store.state.isBack = false;
    }
  }
};

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      positionY: 0,
      timer: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.timer = setInterval(function () {
      _this.positionY++;
    }, 600);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  }
};

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mUtils = __webpack_require__(9);

var mobile = _interopRequireWildcard(_mUtils);

var _lodash = __webpack_require__(136);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  data: function data() {
    return {
      loadingState: 1,
      diff: 0,
      beforeDiff: 0,
      topLoadMethod: false,
      topBlockHeight: 50,
      startY: 0,
      startScrollTop: 0,
      distance: 0,
      refreshText: '下拉刷新',
      state: '',
      triggerDistance: 70,
      parentnode: false
    };
  },

  props: {
    onRefresh: Function,
    onInfinite: Function,
    colorBlack: Boolean,
    noDataText: {
      type: String,
      default: '没有更多数据'
    },
    isAddClass: {
      type: Boolean,
      default: false
    },
    isData: {
      type: Number
    }
  },
  computed: {
    iconLink: function iconLink() {
      var state = this.state;
      var iconLink = '';
      if (state === 'pull' || state === 'trigger') {
        iconLink = '#icon-arrow-bottom';
      } else if (state === 'loading') {
        iconLink = '#icon-loading';
      } else if (state === 'loaded-done') {
        iconLink = '#icon-finish';
      }
      return iconLink;
    }
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    this.deInit();
    mobile.overscroll(document.querySelectorAll('.scrolls'));
    this.topLoadMethod = !!this.onRefresh;
    this.bindEvents();

    this.$refs.my_scroller.addEventListener('scroll', function () {
      _this.$emit('getScrollTop', _this.$refs.my_scroller.scrollTop);
    });
  },
  activated: function activated() {
    this.$store.commit('SET_POSITION', this.$route.name);
  },

  methods: {
    addClass: _lodash2.default.debounce(function () {
      var _this2 = this;

      document.querySelectorAll('.j-addClass').forEach(function (val) {
        if (val.classList.contains('slideInUp')) {
          return;
        }
        if (val.offsetTop - _this2.$refs.my_scroller.clientHeight - _this2.$refs.my_scroller.scrollTop < 0) {
          val.style.cssText = 'opacity: 1;height: auto;';
          val.classList.add('slideInUp');
        }
      });
    }, 10, { 'maxWait': 1000 }),
    deInit: _lodash2.default.debounce(function () {
      if (!this.onInfinite) return;
      if (this.loadingState === 0 || this.loadingState === 2 || this.loadingState === 3) return;
      if (this.$refs.my_scroller.clientHeight > this.$refs.load.offsetTop) {
        this.loadingState = 2;
        this.onInfinite(this.finishInfinite);
        this.deInit();
      } else {
        if (this.$refs.my_scroller.scrollTop + this.$refs.my_scroller.clientHeight - this.$refs.load.clientHeight > this.$refs.load.offsetTop - 50) {
          this.loadingState = 2;
          this.onInfinite(this.finishInfinite);
        }
      }
    }, 300, { 'maxWait': 1000 }),
    finishInfinite: function finishInfinite(hideSpinner) {
      if (this.isAddClass) {
        this.addClass();
      }
      var states = 1;
      switch (hideSpinner) {
        case 'end':
          states = 0;
          break;
        case 'error':
          states = 3;
          break;
        default:
          states = 1;
      }
      this.loadingState = states;
    },
    reload: function reload() {
      if (this.isAddClass) {
        this.addClass();
      }
      if (this.$refs.my_scroller === undefined) {
        return;
      }
      this.loadingState = 1;
      this.$refs.my_scroller.scrollTop = 0;
      this.deInit();
    },
    scroll: function scroll(event) {
      if (this.isAddClass) {
        this.addClass();
      }
      this.deInit();
      this.$store.commit('SAVE_PAGE', { 'target': event, 'ref': 'my_scroller' });
    },
    scrollTo: function scrollTo(y) {
      var _this3 = this;

      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      if (this.$refs.my_scroller_box === undefined) {
        return;
      }
      this.$refs.my_scroller_box.style.transition = duration + 'ms';
      this.diff = y;
      setTimeout(function () {
        _this3.$refs.my_scroller_box.style.transition = '';
      }, duration);
    },
    findParent: function findParent(node) {
      if (node.className.indexOf('no_scroll') > -1) {
        this.parentnode = true;
      } else {
        this.parentnode = false;
        if (node.parentNode === null) {
          return;
        }
        if (node.parentNode.nodeName.toLowerCase() != 'body') {
          this.findParent(node.parentNode);
        }
      }
    },
    touchstart: function touchstart(event) {
      this.startY = event.touches[0].clientY;
      this.beforeDiff = this.diff;
      this.startScrollTop = this.$refs.my_scroller.scrollTop;
      this.state = 'pull';
      this.refreshText = '下拉刷新';
      this.topLoadMethod = false;
    },
    touchmove: function touchmove(event) {
      this.findParent(event.target);
      if (this.parentnode) {
        return;
      }
      this.currentY = event.touches[0].clientY;
      this.distance = (this.currentY - this.startY) / 2 + this.beforeDiff;
      if (this.startScrollTop < 2 && this.distance > 0) {
        this.topLoadMethod = true;
        event.preventDefault();
        event.stopPropagation();
        this.diff = this.distance;
        if (this.distance > this.triggerDistance) {
          this.state = 'trigger';
          this.refreshText = '放手刷新';
        } else {
          this.state = 'pull';
          this.refreshText = '下拉刷新';
        }
      }
    },
    touchend: function touchend() {
      var _this4 = this;

      if (this.topLoadMethod) {
        if (this.diff < this.triggerDistance) {
          this.scrollTo(0);
        } else {
          this.state = 'loading';
          this.scrollTo(this.topBlockHeight);
          this.onRefresh(function () {
            _this4.refreshText = '加载完成';
            _this4.state = 'loaded-done';
            setTimeout(function () {
              _this4.scrollTo(0);
              _this4.reload();
            }, 400);
          });
          this.refreshText = '加载中...';
        }
      }
    },
    bindEvents: function bindEvents() {
      if (this.topLoadMethod) {
        this.$refs.my_scroller_box.addEventListener('touchstart', this.touchstart);
        this.$refs.my_scroller_box.addEventListener('touchmove', this.touchmove);
        this.$refs.my_scroller_box.addEventListener('touchend', this.touchend);
      }
    }
  },
  components: {}
};

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(59);

var _keys2 = _interopRequireDefault(_keys);

var _vue = __webpack_require__(20);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(61);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(58);

var _router2 = _interopRequireDefault(_router);

__webpack_require__(57);

var _mUtils = __webpack_require__(9);

var mobile = _interopRequireWildcard(_mUtils);

var _story = __webpack_require__(19);

var _story2 = _interopRequireDefault(_story);

var _vueAwesomeSwiper = __webpack_require__(60);

var _vueAwesomeSwiper2 = _interopRequireDefault(_vueAwesomeSwiper);

var _getData = __webpack_require__(13);

var getData = _interopRequireWildcard(_getData);

var _components = __webpack_require__(56);

var _components2 = _interopRequireDefault(_components);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _keys2.default)(_components2.default).forEach(function (key) {
  var name = key.replace(/(\w)/, function (v) {
    return v.toUpperCase();
  });
  _vue2.default.component('v' + name, _components2.default[key]);
});
_vue2.default.use(_vueAwesomeSwiper2.default);

_router2.default.afterEach(function (to, from, next) {});

_vue2.default.prototype.golook = function (list) {
  if (list.length) {
    mobile.setStore('pics', list);
    _router2.default.push('/lookPicture');
  }
};
_vue2.default.prototype.golookTxt = function (info) {
  if (info && info.textInfo) {
    mobile.setStore('textInfo', info);
    _router2.default.push('/picture');
  }
};

new _vue2.default({
  el: '#app',
  router: _router2.default,
  store: _story2.default,
  template: '<App/>',
  components: { App: _App2.default }
});

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(93);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(91);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getData = __webpack_require__(13);

var getData = _interopRequireWildcard(_getData);

var _mutationTypes = __webpack_require__(38);

var types = _interopRequireWildcard(_mutationTypes);

var _story = __webpack_require__(19);

var _story2 = _interopRequireDefault(_story);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getCartlist: function getCartlist(_ref) {
    var _this = this;

    var commit = _ref.commit,
        state = _ref.state;
    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
      var res;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getData.shoppingCartNum();

            case 2:
              res = _context.sent;

              commit(types.SAVE_CARTLIST, res.shoppingCartNum);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
};

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {};

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(92);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _types$SAVE_ADDRESS$t;

var _mutationTypes = __webpack_require__(38);

var types = _interopRequireWildcard(_mutationTypes);

var _mUtils = __webpack_require__(9);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_types$SAVE_ADDRESS$t = {}, (0, _defineProperty3.default)(_types$SAVE_ADDRESS$t, types.SAVE_ADDRESS, function (state, newAdress) {
  state.removeAddress = newAdress;
}), (0, _defineProperty3.default)(_types$SAVE_ADDRESS$t, types.SAVE_SEARCHKEY, function (state, searchKey) {
  state.searchKey = searchKey;
}), (0, _defineProperty3.default)(_types$SAVE_ADDRESS$t, types.SAVE_CARTLIST, function (state, cartList) {
  state.cartList = cartList;
}), (0, _defineProperty3.default)(_types$SAVE_ADDRESS$t, types.SAVE_CATEGORYTYPE, function (state, categoryType) {
  state.categoryType = categoryType;
}), (0, _defineProperty3.default)(_types$SAVE_ADDRESS$t, types.SAVE_ACTIVECITY, function (state, activeCity) {
  state.activeCity = activeCity;
}), (0, _defineProperty3.default)(_types$SAVE_ADDRESS$t, types.SAVE_ORDERLIST, function (state, orderList) {
  state.orderList = orderList;
}), (0, _defineProperty3.default)(_types$SAVE_ADDRESS$t, types.SET_POSITION, function (state, routeName) {
  state.arrPageName = routeName;

  var _loop = function _loop(attr) {
    if (routeName == attr) {
      setTimeout(function () {
        state.position[attr].scroller.scrollTo(state.position[attr].pos.left, state.position[attr].pos.top);
      }, 10);
    }
  };

  for (var attr in state.position) {
    _loop(attr);
  }
}), (0, _defineProperty3.default)(_types$SAVE_ADDRESS$t, types.SAVE_PAGE, function (state, _ref) {
  var pos = _ref.pos,
      scroller = _ref.scroller;

  state.position[state.arrPageName] = { pos: pos, scroller: scroller };
}), (0, _defineProperty3.default)(_types$SAVE_ADDRESS$t, types.SET_ACTIVELOCAL, function (state, _ref2) {
  var acitiveLocal = _ref2.acitiveLocal,
      acitiveLocalNo = _ref2.acitiveLocalNo;

  state.acitiveLocal = acitiveLocal;
  state.acitiveLocalNo = acitiveLocalNo;
}), _types$SAVE_ADDRESS$t);

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wxshare = exports.isEmoji = exports.toast = exports.showBack = exports.unique = exports.overscroll = exports.rule = exports.islength = exports.getQueryString = exports.removeStore = exports.getStore = exports.setStore = exports.getSession = exports.setSession = undefined;

var _stringify = __webpack_require__(88);

var _stringify2 = _interopRequireDefault(_stringify);

exports.currency = currency;

var _story = __webpack_require__(19);

var _story2 = _interopRequireDefault(_story);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setSession = exports.setSession = function setSession(name, content) {
  if (!name) return;
  if (typeof content !== 'string') {
    content = (0, _stringify2.default)(content);
  }
  window.sessionStorage.setItem(name, content);
};

var getSession = exports.getSession = function getSession(name) {
  if (!name) return;
  return window.sessionStorage.getItem(name);
};
var setStore = exports.setStore = function setStore(name, content) {
  if (!name) return;
  if (typeof content !== 'string') {
    content = (0, _stringify2.default)(content);
  }
  window.localStorage.setItem(name, content);
};

var getStore = exports.getStore = function getStore(name) {
  if (!name) return;
  return window.localStorage.getItem(name);
};

var removeStore = exports.removeStore = function removeStore(name) {
  if (!name) return;
  window.localStorage.removeItem(name);
};
var getQueryString = exports.getQueryString = function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURI(r[2]);return null;
};

var islength = exports.islength = function islength(num) {
  if (Number(num) < 10) {
    return '0' + num;
  } else {
    return num;
  }
};

var rule = exports.rule = {
  alert: function alert(mess) {
    _story2.default.state.alertMessage = mess;
    _story2.default.state.showAlert = true;
  },
  empty: function empty(str, mess) {
    if (str == '') {
      this.alert(mess);
      return false;
    } else {
      return true;
    }
  },
  phone: function phone(str) {
    var myReg = /^(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
    if (!myReg.test(str)) {
      this.alert('手机号码有误');
      return false;
    } else {
      return true;
    }
  }

};

var overscroll = exports.overscroll = function overscroll(els) {
  for (var i = 0; i < els.length; ++i) {
    console.log(els);
    var el = els[i];
    el.addEventListener('touchstart', function () {
      var top = this.scrollTop,
          totalScroll = this.scrollHeight,
          currentScroll = top + this.offsetHeight,
          left = this.scrollLeft,
          totalScrollWidth = this.scrollWidth,
          currentScrollWidth = top + this.offsetWidth;
      if (top === 0) {
        this.scrollTop = 1;
      } else if (currentScroll === totalScroll) {
        this.scrollTop = top - 1;
      }

      if (left === 0) {
        this.scrollleft = 1;
      } else if (currentScrollWidth === totalScrollWidth) {
        this.scrollleft = left - 1;
      }
    });
    el.addEventListener('touchmove', function (evt) {
      if (this.offsetHeight < this.scrollHeight) {
        evt._isScroller = true;
      }
      if (this.offsetWidth < this.scrollWidth) {
        evt._isScroller = true;
      }
    });
  }
};

var startPageX = 0;
document.body.addEventListener('touchstart', function (evt) {
  startPageX = evt.touches[0].pageX;
});

document.body.addEventListener('touchmove', function (evt) {

  var movePageX = evt.touches[0].pageX;
  console.log(!evt._isScroller);
  if (!evt._isScroller) {
    evt.preventDefault();
  }
}, {
  passive: false
});

Array.prototype.remove = function (val) {
  var index = this.indexOf(val);
  if (index > -1) {
    this.splice(index, 1);
  }
};

var unique = exports.unique = function unique(arr) {
  return arr.filter(function (element, index, self) {
    return self.indexOf(element) === index;
  });
};

Date.prototype.format = function (format) {
  var o = {
    'M+': this.getMonth() + 1,
    'd+': this.getDate(),
    'h+': this.getHours(),
    'm+': this.getMinutes(),
    's+': this.getSeconds(),
    'q+': Math.floor((this.getMonth() + 3) / 3),
    'S': this.getMilliseconds() };
  var week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  if (/(w+)/.test(format)) {
    format = format.replace(RegExp.$1, week[this.getDay()]);
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return format;
};

Date.prototype.add = function (part, value) {
  value *= 1;
  if (isNaN(value)) {
    value = 0;
  }
  switch (part) {
    case 'y':
      this.setFullYear(this.getFullYear() + value);
      break;
    case 'm':
      this.setMonth(this.getMonth() + value);
      break;
    case 'd':
      this.setDate(this.getDate() + value);
      break;
    case 'h':
      this.setHours(this.getHours() + value);
      break;
    case 'n':
      this.setMinutes(this.getMinutes() + value);
      break;
    case 's':
      this.setSeconds(this.getSeconds() + value);
      break;
    default:

  }
  return this;
};

var showBack = exports.showBack = function showBack(el, callback) {
  var requestFram = void 0;
  var oldScrollTop = void 0;

  document.addEventListener('scroll', function () {
    showBackFun();
  }, false);
  document.addEventListener('touchstart', function () {
    showBackFun();
  }, { passive: true });

  document.addEventListener('touchmove', function () {
    showBackFun();
  }, { passive: true });

  document.addEventListener('touchend', function () {
    oldScrollTop = el.getPosition().top;
    moveEnd();
  }, { passive: true });

  var moveEnd = function moveEnd() {
    requestFram = requestAnimationFrame(function () {
      if (el.getPosition().top != oldScrollTop) {
        oldScrollTop = el.getPosition().top;
        moveEnd();
      } else {
        cancelAnimationFrame(requestFram);
      }
      showBackFun();
    });
  };

  var showBackFun = function showBackFun() {
    if (el.getPosition().top > 500) {
      callback(true);
    } else {
      callback(false);
    }
  };
};

var toast = exports.toast = function toast() {
  var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1500;

  var toast = document.createElement('div');
  toast.className = 'common-toast common-toast-show';
  toast.innerHTML = msg;
  document.body.appendChild(toast);
  toast.style.display = 'block';
  toast.style.margin = '-' + toast.offsetHeight / 2 + 'px 0 0 -' + toast.offsetWidth / 2 + 'px';
  var timer = setTimeout(function () {
    toast.className = 'common-toast common-toast-hide';
    clearTimeout(timer);
    var timer2 = setTimeout(function () {
      document.body.removeChild(toast);
      clearTimeout(timer2);
    }, 200);
  }, time);
};

var digitsRE = /(\d{3})(?=\d)/g;

function currency(value, currency, decimals) {
  value = parseFloat(value);
  if (!isFinite(value) || !value && value !== 0) return '';
  currency = currency != null ? currency : '$';
  decimals = decimals != null ? decimals : 2;
  var stringified = Math.abs(value).toFixed(decimals);
  var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
  var i = _int.length % 3;
  var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
  var _float = decimals ? stringified.slice(-1 - decimals) : '';
  var sign = value < 0 ? '-' : '';
  return sign + currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float;
}

var isEmoji = exports.isEmoji = function isEmoji(name) {
  if (escape(name).toLocaleLowerCase().match(/(\%\ue[0-9a-f]{3})|(\%\ud[0-9a-f]{3})/)) {
    return true;
  } else {
    return false;
  }
};

var wxshare = exports.wxshare = function wxshare(wx, shareCont) {
  var title = shareCont.title;
  var shareContent = shareCont.shareContent;
  var url = shareCont.url;
  var imgUrl = shareCont.imgUrl;
  wx.ready(function () {
    wx.checkJsApi({
      jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone']
    });
    wx.onMenuShareTimeline({
      title: title,
      link: url,
      imgUrl: imgUrl,
      success: function success() {
        toast('分享成功');
      },
      cancel: function cancel() {
        toast('取消分享');
      }
    });
    wx.onMenuShareAppMessage({
      title: title,
      desc: shareContent,
      link: url,
      imgUrl: imgUrl,
      type: 'link',
      dataUrl: '',
      success: function success() {
        toast('分享成功');
      },
      cancel: function cancel() {
        toast('取消分享');
      }
    });
    wx.onMenuShareQQ({
      title: title,
      desc: shareContent,
      link: url,
      imgUrl: imgUrl,
      success: function success() {
        toast('分享成功');
      },
      cancel: function cancel() {
        toast('取消分享');
      }
    });
    wx.onMenuShareWeibo({
      title: title,
      desc: shareContent,
      link: url,
      imgUrl: imgUrl,
      success: function success() {
        toast('分享成功');
      },
      cancel: function cancel() {
        toast('取消分享');
      }
    });
    wx.onMenuShareQZone({
      title: title,
      desc: shareContent,
      link: url,
      imgUrl: imgUrl,
      success: function success() {
        toast('分享成功');
      },
      cancel: function cancel() {
        toast('取消分享');
      }
    });
  });
};

/***/ })

},[84]);


// WEBPACK FOOTER //
// static/js/app.b35c2e7c0e1dc84ad31e.js